/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignFloatOperation
 */
export interface AssignFloatOperation {
    /**
     * 
     * @type {number}
     * @memberof AssignFloatOperation
     */
    value: number;
}

/**
 * Check if a given object implements the AssignFloatOperation interface.
 */
export function instanceOfAssignFloatOperation(value: object): value is AssignFloatOperation {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AssignFloatOperationFromJSON(json: any): AssignFloatOperation {
    return AssignFloatOperationFromJSONTyped(json, false);
}

export function AssignFloatOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignFloatOperation {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function AssignFloatOperationToJSON(value?: AssignFloatOperation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

